// extracted by mini-css-extract-plugin
export var growableInput = "_8l-0";
export var tagContainer = "_8l-2";
export var textInput = "_8l-1";